import React from 'react';
import { Typography, Box } from '@mui/material';
import Image from 'next/image';
import classNames from 'classnames';
import NoStyleLink from '../ButtonsLinks/NoStyleLink';
import ImageLoader from '../utils/ImageLoader';
import { useStyles } from './BrowseByTrade.styles';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';

export type TradeCardOverrideType = React.FC<{ name: string }>;
type TradeCardProps = {
  name: string;
  nameComponent: React.ElementType;
  icon: string;
  TradeCardOverride?: TradeCardOverrideType;
  url: string;
};

export default function BrowseByTradeCard({
  name,
  nameComponent,
  icon,
  TradeCardOverride,
  url,
}: TradeCardProps) {
  const classes = useStyles();
  return (
    <Box>
      <AnalyticsWrappedComponent
        componentType={NoStyleLink}
        eventText="Clicked Browse by Trade"
        eventLabel={name}
        data-track-click={`Trade, Navigation, ${name}`}
        href={url}
      >
        <Box className={classNames(classes.tradeContainer)}>
          <Box className={classes.imageContainer}>
            <Image
              loader={ImageLoader}
              src={icon}
              alt=""
              height={80}
              width={175}
              className={classes.tradeImage}
              loading="eager"
            />
          </Box>
          {!TradeCardOverride ? (
            <Box className={classes.textContainer}>
              <Typography
                data-test-id="default-trade-card"
                component={nameComponent}
                variant="h3"
              >
                {name}
              </Typography>
              {/* Add backend component first! <Typography>View X companies</Typography>*/}
            </Box>
          ) : (
            <TradeCardOverride name={name} />
          )}
        </Box>
      </AnalyticsWrappedComponent>
    </Box>
  );
}
